"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useInstantSearch } from "react-instantsearch";
import { createPiiScrubMiddleware } from "@/lib/search/piiScrubMiddleware";
export function PiiScrubBridge() {
  const $ = _c(3);
  const {
    addMiddlewares
  } = useInstantSearch();
  let t0;
  let t1;
  if ($[0] !== addMiddlewares) {
    t0 = () => {
      const middleware = createPiiScrubMiddleware();
      return addMiddlewares(middleware);
    };
    t1 = [addMiddlewares];
    $[0] = addMiddlewares;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}